
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselRemoteIndicator as ObiVesselRemoteIndicatorElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-remote-indicator.js';
 
 
 

 
 export const ObiVesselRemoteIndicator = createComponent({
   react: React,
   tagName: 'obi-vessel-remote-indicator',
   elementClass: ObiVesselRemoteIndicatorElement,
   events: {
     
   }
  });
 
 